import { render, staticRenderFns } from "./DanweiList.vue?vue&type=template&id=44fb1480&"
import script from "./DanweiList.vue?vue&type=script&lang=js&"
export * from "./DanweiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports